<script>
import DriverShiftEndDetailComponent from '@/components/DriverShiftEndDetailComponent'
import MainLayout from '@/router/layouts/mainLayout'
export default {
  components: {
    DriverShiftEndDetailComponent, MainLayout
  },
  data () {
    return {
      shiftId: '',
      // backName: (this.$route.query.from === 'MovementStatus') || (this.$route.query.from === 'MovementShift') ? '運行便に戻る' : 'スケジュールに戻る'
      backName: 'スケジュールに戻る'
    }
  },
  methods: {
    getShiftId (val) {
      this.shiftId = val
    }
  }
}
</script>
<template>
<main-layout>
  <driver-shift-end-detail-component
    :backName="backName"
    :rightTopBtn= true
    :shiftStatus= 3
    :mapBtnVisibility= true
    @transShiftID="getShiftId">
  </driver-shift-end-detail-component>
</main-layout>
</template>



// WEBPACK FOOTER //
// src/router/views/DriverShiftEndDetail.vue